import type { JSX } from 'react';

import BlocksLogo from 'components/DesignSystem/Icons/adhoc/BlocksLogo';
import SquareImage from 'components/Image/SquareImage';
import { Palette } from 'DesignSystem2/Theme';
import Body from 'DesignSystem3/Text/Body';

import OddsAndChange from './OddsAndChange';

interface FaceOffRowProps {
    rulebook_variables: { [variable: string]: string };
    yes_sub_title: string;
    odds: number;
    change: number;
    largerText?: boolean;
    textColor?: string;
}

const FaceOffRow = ({
    rulebook_variables,
    yes_sub_title,
    odds,
    change,
    largerText = false,
    textColor,
}: FaceOffRowProps): JSX.Element => {
    const renderImage = () => {
        // Show BlocksLogo if no image_link
        if (!rulebook_variables.image_link) {
            return (
                <div
                    style={{
                        width: 32,
                        height: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <BlocksLogo height="32px" color={Palette.Fill.x30} />
                </div>
            );
        }

        return <SquareImage src={rulebook_variables.image_link} size={32} alt={yes_sub_title} />;
    };

    return (
        <div className="flex items-center self-stretch gap-3 align-center">
            <div className="flex items-center justify-center">{renderImage()}</div>
            <div className="flex-1 min-w-0 leading-none">
                {largerText ? (
                    <Body.x30 style={textColor ? { color: textColor } : undefined}>{yes_sub_title}</Body.x30>
                ) : (
                    <Body.x20 style={textColor ? { color: textColor } : undefined}>{yes_sub_title}</Body.x20>
                )}
            </div>
            <OddsAndChange odds={odds} change={change} showChange={true} size="large" textColor={textColor} />
        </div>
    );
};

export default FaceOffRow;
